import palette from './palette';

const shadows = [
  'none',
  `0px 4px 4px ${palette.alpha(palette.gray[12], 0.25)}`,
  `0px 8px 24px 0px ${palette.alpha(palette.gray[12], 0.16)}`,
  `0px 16px 32px 0px ${palette.alpha(palette.gray[12], 0.16)}`,
  `0px 16px 48px 0px ${palette.alpha(palette.gray[12], 0.24)}`
];

export default shadows;
